<template>
  <b-modal
    id="modal-box"
    :no-close-on-backdrop="true"
    :no-close-on-esc="false"
    :title="editItem?editItem.boxTitle:'Add Box'"
    size="lg"
    @ok="handleOk"
  >
    <form-box
      ref="box_form"
      v-model="editItem"
      :page-id="pageId"
      @submit="submitted"
      @drillAdded="drillAdded"
    />
  </b-modal>
</template>

<script>
import {
  BModal, VBModal,
} from 'bootstrap-vue'

import FormBox from './forms/FormBox.vue'

export default {
  components: {
    BModal,
    FormBox,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    pageId: {
      type: [String, Number],
      required: true,
    },
    editItem: {
      type: Object,
      default: null,
    },
  },
  methods: {
    submitted(id) {
      this.$emit('submit', id)
      this.$bvModal.hide('modal-box')
    },
    drillAdded(id) {
      this.$emit('drillAdded', id)
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.$refs.box_form.validationForm()
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style>
.vs__dropdown-toggle {
  border:1px solid #d8d6de !important
}
</style>
